// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/singular_day_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SingularDayService } from "./singular_day_service_pb";

/**
 * ListSingularDays returns every active SingularDay for the current
 * organization within the given fiscal year. organization_id is
 * resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.ListSingularDays
 */
export const listSingularDays = SingularDayService.method.listSingularDays;

/**
 * CreateSingularDay registers a new SingularDay (or revives a tombstone
 * date, AC-11). organization_id and created_by are resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.CreateSingularDay
 */
export const createSingularDay = SingularDayService.method.createSingularDay;

/**
 * UpdateSingularDay updates the name / category / demand_behavior of an
 * existing SingularDay. date is immutable after creation. Uses optimistic
 * locking via expected_updated_at. organization_id and updated_by are
 * resolved by the BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.UpdateSingularDay
 */
export const updateSingularDay = SingularDayService.method.updateSingularDay;

/**
 * DeleteSingularDay logically deletes a SingularDay. Uses optimistic
 * locking via expected_updated_at. organization_id is resolved by the
 * BFF handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.DeleteSingularDay
 */
export const deleteSingularDay = SingularDayService.method.deleteSingularDay;

/**
 * ListSingularGroupNames returns every 命名済み 特異グループ display name
 * for the current organization. organization_id is resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.ListSingularGroupNames
 */
export const listSingularGroupNames = SingularDayService.method.listSingularGroupNames;

/**
 * SaveSingularGroupNames applies a per-group upsert batch: a non-empty
 * entry name upserts that group's display name, an empty name deletes it
 * (= 既定名に戻す). organization_id and updated_by are resolved by the BFF
 * handler from eauth.
 *
 * @generated from rpc bffuser.v1.SingularDayService.SaveSingularGroupNames
 */
export const saveSingularGroupNames = SingularDayService.method.saveSingularGroupNames;
